// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"t0-z","sponsoredTooltipWrapper":"u0-z","sponsoredTooltip":"v0-z","newCard":"w0-z"};